import { get, post,postEspec,baseUrl} from './http'
let apiPath='lechun-cms';
let apiBalancePath='lechun-balance';
let apiMonitorPath='lechun-monitor';
let apiBaseservicePath='lechun-baseservice'
let apiMarketPath='lechun-market'
let apiBiPath='lechun-bi'
//登录
export const login = params =>get(`${apiPath}/comm/login`,params)//登录
export const logout = params =>get(`${apiPath}/comm/logout`,params)//退出登录
export const getUserDetail = params =>get(`${apiPath}/comm/getUserDetail`,params)//获取用户信息

//菜单
export const getSysUserMenu = params =>get(`${apiPath}/comm/getSysUserMenu`,params)//获取菜单

//公共接口
export const platFormGroupList=params=>get(`${apiPath}/comm/platFormGroupList`,params)
export const platFormList=params=>get(`${apiPath}/comm/platFormList`,params)
export const getAllUsers=params=>get(`${apiPath}/user/getUserListForDorpbox`,params)
export const allPlatFormGroupList=params=>get(`${apiPath}/comm/allPlatFormGroupList`,params)//包含 0全部
export const allMyPlatFormGroupList=params=>get(`${apiPath}/comm/allPlatFormGroupList`,params)//包含 0全部 只有自己是0的时候

//定时任务
export const getQuartzList = params =>get(`${apiPath}/quartz/getQuartzList`,params)//获取定时任务列表
export const getQuartzJobGroupList = params =>get(`${apiPath}/quartz/getQuartzJobGroupList`,params)//获取定时任务分组列表
export const addQuartzJob = params =>get(`${apiPath}/quartz/addQuartzJob`,params)//添加定时任务
export const pauseJob = params =>get(`${apiPath}/quartz/pauseJob`,params)//暂停定时 任务
export const resumeJob = params =>get(`${apiPath}/quartz/resumeJob`,params)//恢复定时任务
export const deleteJob = params =>get(`${apiPath}/quartz/deleteJob`,params)//删除定时任务
export const executeOneceJob = params =>get(`${apiPath}/quartz/executeOneceJob`,params)//立即执行定时任务
export const modifyJobTime = params =>get(`${apiPath}/quartz/modifyJobTime`,params)//修改定时任务
//模板
export const getBuildPageTree=params=>get(`${apiPath}/item/getbuildpagetree`,params)
export const getBuildPageList=params=>get(`${apiPath}/item/getbuildpagelist`,params)
export const getbuildpage=params=>get(`${apiPath}/item/getbuildpage`,params)
export const getPlatformList=params=>get(`${apiPath}/platform/getplatformlist`,params)
export const getPlatformList2=params=>get(`${apiPath}/platform/getplatformlist2`,params)
export const saveBuildPage =params=>post(`${apiPath}/item/savebuildpage`,params)
export const deleteBuildPage =params=>get(`${apiPath}/item/deletebuildPage`,params)
export const getShowNavAndIcon =params=>get(`${apiPath}/item/getShowNavAndIcon`,params)
export const showNav =params=>get(`${apiPath}/item/showNav`,params)
export const showNavIcon =params=>get(`${apiPath}/item/showNavIcon`,params)

//首页配置
export const getIndexNavTree=params=>get(`${apiPath}/item/getIndexNavTree`,params)
export const getIndexNavList=params=>get(`${apiPath}/item/getIndexNavList`,params)
export const getIndexNav=params=>get(`${apiPath}/item/getIndexNav`,params)
export const saveIndexNav =params=>post(`${apiPath}/item/saveIndexNav`,params)
export const deleteIndexNav =params=>get(`${apiPath}/item/deleteIndexNav`,params)
export const getIndexNavTypeList =params=>get(`${apiPath}/item/getIndexNavTypeList`,params)

export const getIndexItemList=params=>get(`${apiPath}/item/getIndexItemList`,params)
export const getIndexItem=params=>get(`${apiPath}/item/getIndexItem`,params)
export const saveIndexItem =params=>post(`${apiPath}/item/saveIndexItem`,params)
export const deleteIndexItem =params=>get(`${apiPath}/item/deleteIndexItem`,params)
export const getItems =params=>get(`${apiPath}/item/getItems`,params)
export const buildModulePage =params=>get(`${apiPath}/item/buildModulePage`,params)
export const getItemList=params=>get(`${apiPath}/item/getItemList`,params)
//页面连接配置
export const getPageLinkList=params=>get(`${apiPath}/pageLink/getPageLinkList`,params)
export const savePageLink=params=>get(`${apiPath}/pageLink/savePageLink`,params)
export const deletePageLink=params=>get(`${apiPath}/pageLink/delete`,params)
export const getPageLink=params=>get(`${apiPath}/pageLink/getPageLink`,params)
export const getPageLinkTypeList=params=>get(`${apiPath}/pageLink/getPageLinkTypeList`,params)

//配置管理
export const getDictionaryTypeList = params =>get(`${apiPath}/dictionary/getDictionaryTypeList`,params)//获取分类列表
export const getValidDictionaryList = params =>get(`${apiPath}/dictionary/getValidDictionaryList`,params)//获取列表
export const getValiddictionarylist2 = params =>get(`${apiPath}/dictionary/getvaliddictionarylist`,params)//获取列表 不分页
export const saveDictionaryType = params =>get(`${apiPath}/dictionary/saveDictionaryType`,params)//新增分类
export const updateOrSaveDictionary = params =>get(`${apiPath}/dictionary/updateOrSaveDictionary`,params)//修改
export const deleteDictionary = params =>get(`${apiPath}/dictionary/deleteDictionary`,params)//删除
export const getDictionary = params =>get(`${apiPath}/dictionary/getDictionary`,params)//删除
export const getAction = params =>get(`${apiPath}/dictionary/getAction`,params)//删除
export const getMyTemplatesList = params =>get(`${apiBaseservicePath}/intellect/getMyTemplatesList`,params)//智齿彩信模板

//图片管理
export const getImageTypeList = params =>get(`${apiPath}/image/getImageTypeList`,params)//获取分类列表
export const saveImageType = params =>get(`${apiPath}/image/saveImageType`,params)//保存
export const getImageList = params =>get(`${apiPath}/image/getImageList`,params)//获取列表
export const saveImagepth =`${baseUrl}/zuul/lechun-cms/image/saveImage`
export const deleteImage = params =>get(`${apiPath}/image/deleteImage`,params)//删除
export const changeImageListSort = params =>get(`${apiPath}/productpic/modifyProductPicSort`,params)//修改排序

//系统管理
export const getCache = params =>get(`${apiPath}/system/getCache`,params)//查询缓存
export const updateCache = params =>post(`${apiPath}/system/updateCache`,params)//更新缓存
export const deleteCache = params =>post(`${apiPath}/system/deleteCache`,params)//删除缓存


//优惠劵管理
export const getCashticketBatchList = params =>get(`${apiPath}/cash/getCashticketBatchList`,params)//查询批次类别
export const getQueryList = params =>get(`${apiPath}/cash/getQueryList`,params)//查询条件
export const updateOrAddCashticketBatch = params =>get(`${apiPath}/cash/updateOrAddCashticketBatch`,params)//查询条件
export const deleteCashticketBatch = params =>get(`${apiPath}/cash/deleteCashticketBatch`,params)//查询条件
export const getCashticketGetList = params =>get(`${apiPath}/cash/getCashticketGetList`,params)//查询条件
export const getCashticketDetail = params =>get(`${apiPath}/cash/getCashticketBatch`,params)//查询条件
export const getCashticketStatusList = params =>get(`${apiPath}/cash/getCashticketStatusList`,params)//查询条件
export const updateCashticketStatus = params =>get(`${apiPath}/cash/updateCashticketStatus`,params)//查询条件
export const getCashticketBatchUseRuleList = params =>get(`${apiPath}/cash/getCashticketBatchUseRuleList`,params)//查询条件
export const saveCashRule = params =>post(`${apiPath}/cash/saveCashRule`,params)//查询条件
export const deleteCashRule = params =>get(`${apiPath}/cash/deleteCashRule`,params)//查询条件
export const getCashRuleTypeList = params =>get(`${apiPath}/cash/getCashRuleTypeList`,params)//查询条件
export const getCashticketBatchForOption= params =>get(`${apiPath}/cash/getCashticketBatchForOption`,params)//下拉列表
export const downloadCashticketListApi = `${baseUrl}/${apiPath}/cash/downloadCashticketList`//优惠券导出
//优惠券设置缓存
export const setCashCache= params =>get(`${apiPath}/cash/setCashCache`,params)
export const getCashSendLogList= params =>get(`${apiPath}/cashLog/getList`,params)//优惠券发放日志列表
export const uploadCashLogApi=`${baseUrl}/${apiPath}/cashLog/upload` //用户上传
export const downLoadCashLogApi=`${baseUrl}/${apiPath}/cashLog/downLoad` //下载导入模板

export const getProductItem= params =>get(`${apiPath}/proItem/getItem`,params)//查询商品信息

//优惠劵创建规则
export const getCashticketUserInfoList=params=>get(`${apiPath}/cash/getCashticketUserInfoList`,params)
export const updateOrAddCashtickeUserInfo=params=>get(`${apiPath}/cash/updateOrAddCashtickeUserInfo`,params)
//查询优惠券创建规则和已保存的规则
export const getCashRuleItemListApi=params=>get(`${apiPath}/cash/getCashRuleItemList`,params)
export const getSelectCashRuleItemList=params=>get(`${apiPath}/cash/getSelectCashRuleItemList`,params)
export const getProductCashList=params=>get(`${apiPath}/cash/getProductItemCashList`,params)
//批量保存优惠券规则
export const saveCashRuleNew=params=>get(`${apiPath}/cash/saveCashRuleNew`,params)
export const deleteProductCashRule=params=>get(`${apiPath}/cash/deleteProductCashRule`,params)
export const saveCashRuleListApi=params=>post(`${apiPath}/cash/saveCashRuleList`,params)
export const saveCashRuleList2Api=params=>post(`${apiPath}/cash/saveCashRuleList2`,params)
//删除优惠券使用规则明细
export const deleteCashRuleDetail=params=>post(`${apiPath}/cash/deleteCashRuleDetail`,params)
//优惠券
export const getCashRuleStatusList=params=>get(`${apiPath}/cash/getCashRuleStatusList`,params)
export const saveCashRuleStats=params=>get(`${apiPath}/cash/saveCashRuleStats`,params)
export const getMallItemConfigUseStatusList=params=>get(`${apiPath}/cash/getMallItemConfigUseStatusList`,params)


//微信消息，模板消息、消息配置
export const listMessageConfig=params=>get(`${apiPath}/wexinMessage/listMessageConfig`,params)
export const selectMessageConfig=params=>get(`${apiPath}/wexinMessage/selectMessageConfig`,params)
export const saveMessageConfig =params=>post(`${apiPath}/wexinMessage/saveMessageConfig`,params)
export const deleteMessageConfig =params=>get(`${apiPath}/wexinMessage/deleteMessageConfig`,params)
export const saveTemplateMessage=params=>post(`${apiPath}/wexinMessage/saveTemplateMessage`,params)
export const selectTemplateMessage=params=>get(`${apiPath}/wexinMessage/selectTemplateMessage`,params)
export const listTemplateMessage =params=>get(`${apiPath}/wexinMessage/listTemplateMessage`,params)
export const deleteTemplateMessage =params=>get(`${apiPath}/wexinMessage/deleteTemplateMessage`,params)
export const getPlateMessageContentList =params=>get(`${apiPath}/wexinMessage/getPlateMessageContentList`,params)
export const getPlateMessageContent =params=>get(`${apiPath}/wexinMessage/getPlateMessageContent`,params)
export const savePlateMessageContent =params=>get(`${apiPath}/wexinMessage/savePlateMessageContent`,params)
export const deletePlateMessageContent =params=>get(`${apiPath}/wexinMessage/deletePlateMessageContent`,params)
export const getWeekList =params=>get(`${apiPath}/wexinMessage/getWeekList`,params)
export const saveTemplateLogMessage=params=>get(`${apiPath}/wexinMessage/saveTemplateLogMessage`,params)
export const getTemplateMessagesOption=params=>get(`${apiPath}/wexinMessage/getTemplateMessagesOption`,params)
export const testSendMessage=params=>get(`${apiPath}/wexinMessage/testSendMessage`,params)
export const putAllUsersIntoRedisSet=params=>get(`${apiPath}/wexinMessage/putAllUsersIntoRedisSet`,params)
export const pushAll=params=>get(`${apiPath}/wexinMessage/pushAll`,params)
export const pushNoticeMQ=params=>get(`${apiPath}/wexinMessage/pushNoticeMQ`,params)
export const pushCustomizedNoticeMQ=params=>get(`${apiPath}/wexinMessage/pushCustomizedNoticeMQ`,params)
export const getCustomerNum=params=>get(`${apiPath}/wexinMessage/pushCustomerNum`,params)
export const deleteImportCustomer=params=>get(`${apiPath}/wexinMessage/deleteImportCustomer`,params)
export const importCustomerInfoUrl=`${baseUrl}/${apiPath}/wexinMessage/importCustomerInfoUrl`
export const downLoadMessageTemplate=`${baseUrl}/${apiPath}/wexinMessage/downLoad`
export const initWeixinTemplate=params=>get(`${apiPath}/wexinMessage/initWeixinTemplate`,params)
export const previewMessageConfig=params=>get(`${apiPath}/wexinMessage/sendPreview`,params)
export const downLoadSubscriptUser=`${baseUrl}/${apiPath}/wexinMessage/downLoadSubscriptUser`
//促销管理
export const promotionList=params=>get(`${apiPath}/promotion/promotionList`,params)
export const getPromotion=params=>get(`${apiPath}/promotion/getPromotion`,params)
export const getPromotionDetail=params=>get(`${apiPath}/promotion/getPromotionDetail`,params)
export const addPromotion =params=>get(`${apiPath}/promotion/addPromotion`,params)
export const addPromotionDetail=params=>get(`${apiPath}/promotion/addPromotionDetail`,params)
export const getPromotionLimitTypeList =params=>get(`${apiPath}/promotion/getPromotionLimitTypeList`,params)
export const delPromotion =params=>get(`${apiPath}/promotion/delPromotion`,params)
export const clearPromotionBuy =params=>get(`${apiPath}/promotion/clearPromotionBuy`,params)
export const getPromotionProduct =params=>get(`${apiPath}/promotion/getPromotionProduct`,params)
export const addPromotionProduct=params=>post(`${apiPath}/promotion/addPromotionProduct`,params)
export const getDeliverConfig=params=>get(`${apiPath}/promotion/getDeliverConfig`,params)
export const saveDeliverConfig=params=>post(`${apiPath}/promotion/saveDeliverConfig`,params)
export const getPromotionTransportType=params=>get(`${apiPath}/promotion/getPromotionTransportType`,params)
export const getPromotionOrder=params=>get(`${apiPath}/promotion/getPromotionOrder`,params)
export const getActivePromotions=params=>get(`${apiPath}/promotion/getActivePromotions`,params)
export const getActivePromotionsByActiveType=params=>get(`${apiPath}/promotion/getActivePromotionsByActiveType`,params)
export const setOnlineOrOffLine=params=>get(`${apiPath}/promotion/setOnlineOrOffLine`,params)

// 价盘管理
export const getPromotionAndProductPriceList=params=>get(`${apiPath}/promotion/getPromotionAndProductPriceList`,params)
export const modifyProPrice=params=>get(`${apiPath}/promotion/modifyProPrice`,params)
export const changePrice=params=>get(`${apiPath}/promotion/changePrice`,params)
export const getCurrentPriceMode=params=>get(`${apiPath}/promotion/getCurrentPriceMode`,params)

//轮播图˚
export const getScrollPicType=params=>get(`${apiPath}/scrollpic/getScrollPicType`,params)
export const getMallScrollPicList=params=>get(`${apiPath}/scrollpic/getMallScrollPicList`,params)
export const updateOrSaveScrollPic =params=>get(`${apiPath}/scrollpic/updateOrSaveScrollPic`,params)
export const getPlatFormList =params=>get(`${apiPath}/scrollpic/getPlatFormList`,params)
export const getMallScrollPicDetailList =params=>get(`${apiPath}/scrollpic/getMallScrollPicDetailList`,params)
export const updateOrSaveScrollPicDetail =params=>get(`${apiPath}/scrollpic/updateOrSaveScrollPicDetail`,params)

//商品Pic
export const getProductPics=params=>get(`${apiPath}/productpic/getProductPics`,params)
export const addProductPic=params=>get(`${apiPath}/productpic/addProductPic`,params)
export const removeProductPic=params=>get(`${apiPath}/productpic/removeProductPic`,params)
export const clearProductPicByProId=params=>get(`${apiPath}/productpic/clearProductPic`,params)
export const ensureSelectPicList=params=>get(`${apiPath}/productpic/addProductPicByBatch`,params)
//export const ensureSelectPicList=params=>post(`${apiPath}/promotion/addProductPicByBatch`,params)

//商品
export const getProductType=params=>get(`${apiPath}/product/proTypeList`,params)
export const getProductList=params=>get(`${apiPath}/product/prolist`,params)
export const delProduct=params=>get(`${apiPath}/product/delProduct`,params)
export const getProduct=params=>get(`${apiPath}/product/getProduct`,params)
export const getProducts=params=>get(`${apiPath}/product/getProducts`,params)
export const addProduct=params=>get(`${apiPath}/product/addProduct`,params)
export const getProductByProType=params=>get(`${apiPath}/product/getProductByProType`,params)
export const getConfigSalesTypeList=params=>get(`${apiPath}/product/getSalesTypeList`,params)
export const getProductsList4Erp=params=>get(`${apiPath}/product/getProductsList4Erp`,params)
export const getProductsTypeList=params=>get(`${apiPath}/product/getProductsTypeList`,params)
export const getWxStoreSearch=params=>get(`${apiPath}/product/getWxStoreSearch`,params)
//单品品类
export const getCategoryList=params=>get(`${apiPath}/product/getCategoryList`,params)
//单品用途
export const getProductCheckUseList=params=>get(`${apiPath}/product/getSaleItemList`,params)

//超级会员商品价格保存
export const saveProductPrice=params=>get(`${apiPath}/productPrice/saveProductPrice`,params)
//超级会员商品列表
export const getProductPriceList=params=>get(`${apiPath}/productPrice/getProductPriceList`,params)
//超级会员商品删除
export const delPrice=params=>get(`${apiPath}/productPrice/delPrice`,params)

//套装
export const getGroupList=params=>get(`${apiPath}/group/grouplist`,params)
export const delGroup=params=>get(`${apiPath}/group/delGroup`,params)
export const getGroup=params=>get(`${apiPath}/group/getGroup`,params)
export const addGroup=params=>post(`${apiPath}/group/addGroup`,params)
export const getGroupProduct=params=>get(`${apiPath}/group/getGroupProductCms`,params)
export const getGroupProductList=params=>get(`${apiPath}/group/getGroupProductList`,params)
export const addGroupProduct=params=>get(`${apiPath}/group/addGroupProduct`,params)
export const delGroupProduct=params=>get(`${apiPath}/group/delGroupProduct`,params)
export const syncGroupsToBD=params=>get(`${apiPath}/group/syncGroupsToBD`,params)

//系统用户
export const getMallUserList=params=>get(`${apiPath}/user/getMallUserList`,params)
export const saveOrUpdateMallUser=params=>post(`${apiPath}/user/saveOrUpdateMallUser`,params)
export const updatePassWord = params =>get(`${apiPath}/user/updatePassWord`,params)//删除缓存
export const getMainDataUsers = params =>get(`${apiPath}/user/getMainDataUsers`,params)
export const getDeparts = params =>get(`${apiPath}/user/getDeparts`,params)
export const getDepartsCascader = params =>get(`${apiPath}/user/getDepartsCascader`,params)

//系统角色
export const saveOrUpdateMallRole=params=>get(`${apiPath}/role/saveOrUpdateMallRole`,params)
export const getMallRoleList=params=>get(`${apiPath}/role/getMallRoleList`,params)
export const findRoleList=params=>get(`${apiPath}/role/findRoleList`,params)

//系统资源
export const saveOrUpdateMallResource=params=>get(`${apiPath}/resource/saveOrUpdateMallResource`,params)
export const getMallParentResourceList=params=>get(`${apiPath}/resource/getMallParentResourceList`,params)
export const getMallleafResourceList=params=>get(`${apiPath}/resource/getMallleafResourceList`,params)
export const getResourceGroups=params=>get(`${apiPath}/resource/getResourceGroups`,params)
export const getResourceGroupUsers=params=>get(`${apiPath}/resource/getResourceGroupUsers`,params)
export const saveResourceGroups=params=>get(`${apiPath}/resource/saveResourceGroups`,params)
export const saveResourceGroupUsers=params=>get(`${apiPath}/resource/saveResourceGroupUsers`,params)
export const saveResourceGroupRelation=params=>get(`${apiPath}/resource/saveResourceGroupRelations`,params)
export const delResourceGroup=params=>get(`${apiPath}/resource/delResourceGroup`,params)


//用户角色
export const getMallUserRoleList=params=>get(`${apiPath}/user/getMallUserRoleList`,params)
export const saveUserRole=params=>postEspec(`${apiPath}/user/saveUserRole`,params)
export const deleteUserRole=params=>get(`${apiPath}/user/deleteUserRole`,params)

//角色资源
export const getMallRoleResourceList=params=>get(`${apiPath}/role/getMallRoleResourceList`,params)
export const saveRoleResource=params=>postEspec(`${apiPath}/role/saveRoleResource`,params)
export const deleteRoleResource=params=>get(`${apiPath}/role/deleteRoleResource`,params)

//省市区
export const getProvinceCity =params=>get(`${apiPath}/common/getProvinceCity`,params)
export const getProvinceCityMap =params=>get(`${apiPath}/common/getProvinceCityMap`,params)
//查配送城市
export const getEnableallCityList =params=>get(`${apiPath}/common/getEnableallCityList`,params)

//平台
export const getPlatFormGroupList=params=>get(`${apiPath}/platform/getPlatFormGroupList`,params)
export const saveOrUpdatePlatFormGroup=params=>get(`${apiPath}/platform/saveOrUpdatePlatFormGroup`,params)
export const getPlatFormTypeList=params=>get(`${apiPath}/platform/getPlatFormTypeList`,params)
export const getAllPlatFormList=params=>get(`${apiPath}/platform/getAllPlatFormList`,params)
export const saveOrUpdatePlatForm=params=>get(`${apiPath}/platform/saveOrUpdatePlatForm`,params)

//长期订购
export const findAllProducts=params=>get(`${apiPath}/regular/findAllProducts`,params)
export const saveOrUpdateRegularProduct=params=>get(`${apiPath}/regular/saveOrUpdateRegularProduct`,params)
export const getRegularList=params=>get(`${apiPath}/regular/getRegularList`,params)
export const saveOrUpdateRegular=params=>get(`${apiPath}/regular/saveOrUpdateRegular`,params)
export const getRegularTypeList=params=>get(`${apiPath}/regular/getRegularTypeList`,params)

//微信相关
export const getKeywordsList=params=>get(`${apiPath}/keyworldManage/getKeywordsList`,params)
export const getKeywordsDetail=params=>get(`${apiPath}/keyworldManage/getKeywordEntity`,params)
export const deleteKeyword=params=>get(`${apiPath}/keyworldManage/deleteKeyword`,params)
export const getKeyword=params=>get(`${apiPath}/keyworldManage/getKeyword`,params)
export const saveKeywords=params=>post(`${apiPath}/keyworldManage/saveKeywords`,params)
export const getKeywordsOption=params=>get(`${apiPath}/keyworldManage/getKeywordsOptionList`,params)
export const getKeywordContentList=params=>get(`${apiPath}/keyworldManage/getKeywordContentList`,params)
export const getKeywordMessageContent=params=>get(`${apiPath}/keyworldManage/getKeywordMessageContent`,params)
export const deleteKeywordMessageContent=params=>get(`${apiPath}/keyworldManage/deleteKeywordMessageContent`,params)
export const saveKeywordMessageContent=params=>post(`${apiPath}/keyworldManage/saveKeywordMessageContent`,params)


export const getMediaList=params=>get(`${apiPath}/mediaManage/getMediaList`,params)
export const getMediaDataList=params=>get(`${apiPath}/mediaManage/getMediaDataList`,params)
export const getMediaforOptions=params=>get(`${apiPath}/mediaManage/getMediaforOptions`,params)
export const deleteMedia=params=>get(`${apiPath}/mediaManage/deleteMedia`,params)
export const getMedia=params=>get(`${apiPath}/mediaManage/getMedia`,params)
export const saveMedia=params=>post(`${apiPath}/mediaManage/saveMedia`,params)
export const pullMediaList=params=>get(`${apiPath}/mediaManage/pullMediaList`,params)
export const getMediaListOption=params=>get(`${apiPath}/mediaManage/getMediaListOption`,params)

export const getWeiXinBaseList=params=>get(`${apiPath}/weiXinBaseManage/getWeiXinBaseList`,params)
export const getWeiXinBase=params=>get(`${apiPath}/weiXinBaseManage/getWeiXinBase`,params)
export const saveWeiXinBase=params=>post(`${apiPath}/weiXinBaseManage/saveWeiXinBase`,params)

export const getWechatGroupList=params=>get(`${apiPath}/weiXinGroupManage/getGroupList`,params)
export const getWechatGroups=params=>get(`${apiPath}/weiXinGroupManage/getGroups`,params)
export const getWechatGroup=params=>get(`${apiPath}/weiXinGroupManage/getGroup`,params)
export const saveWechatGroup=params=>get(`${apiPath}/weiXinGroupManage/saveGroup`,params)
export const uploadGroupUsers=params=>get(`${apiPath}/weiXinGroupManage/uploadGroupUsers`,params)
export const getSendMessageStatus=params=>get(`${apiPath}/weiXinGroupManage/getSendMessageStatus`,params)
export const sendGroupMessage=params=>get(`${apiPath}/weiXinGroupManage/sendMessage`,params)
export const delGroupMessage=params=>get(`${apiPath}/weiXinGroupManage/delMessage`,params)

export const sendCustomizedMessage=params=>get(`${apiPath}/weiXinGroupManage/sendCustomizedMessage`,params)
export const deleteByWechatGroupId=params=>get(`${apiPath}/weiXinGroupManage/deleteByGroupId`,params)
export const searchGroup1=params=>post(`${apiPath}/weiXinGroupManage/searchGroup1`,params)
export const setStaffSerivceApi=params=>post(`${apiPath}/paySerivce/setStaffSerivce`,params)
export const getTemplateMessageLogList=params=>get(`${apiPath}/wexinMessage/getTemplateMessageLogList`,params)
export const getTemplateMessageLogTotalList=params=>get(`${apiPath}/wexinMessage/getTemplateMessageLogTotalList`,params)

export const getMiniCardList=params=>get(`${apiPath}/mediaManage/getMiniCardList`,params)
export const saveMiniCard=params=>get(`${apiPath}/mediaManage/saveMiniCard`,params)
export const deleteMiniCard=params=>get(`${apiPath}/mediaManage/deleteMiniCard`,params)

//微信菜单
export const getWeiXinMenuList=params=>get(`${apiPath}/weiXinMenu/getWeiXinMenuList`,params)
export const pushMenu=params=>get(`${apiPath}/weiXinMenu/pushMenu`,params)
export const saveMenu=params=>get(`${apiPath}/weiXinMenu/saveMenu`,params)
export const pullMenu=params=>post(`${apiPath}/weiXinMenu/pullMenu`,params)
export const deleteMenu=params=>get(`${apiPath}/weiXinMenu/deleteMenu`,params)
export const getMenuKey=params=>get(`${apiPath}/weiXinMenu/getMenuKey`,params)

//满减
export const getFullCutList=params=>get(`${apiPath}/fullcut/getFullCutList`,params)
export const saveOrUpdateFullCutList=params=>postEspec(`${apiPath}/fullcut/saveOrUpdateFullCutList`,params)
export const getFullCutDetailList=params=>get(`${apiPath}/fullcut/getFullCutDetailList`,params)
export const getFullCutDetail=params=>get(`${apiPath}/fullcut/getFullCutEntity`,params)
export const saveMallFullcutDetail=params=>postEspec(`${apiPath}/fullcut/saveMallFullcutDetail`,params)
export const deleteMallFullcutDetail=params=>get(`${apiPath}/fullcut/deleteMallFullcutDetail`,params)
export const getProductListL=params=>get(`${apiPath}/fullcut/getProductList`,params)
export const getGroupListL=params=>get(`${apiPath}/fullcut/getGroupList`,params)
export const getActiveListL=params=>get(`${apiPath}/fullcut/getActiveList`,params)

//赠品
export const getFreeList=params=>get(`${apiPath}/free/getFreeList`,params)
export const getFreeProductList=params=>get(`${apiPath}/free/getFreeProductList`,params)
export const getFreeRuleList=params=>get(`${apiPath}/free/getFreeRuleList`,params)
export const saveOrUpdateFree=params=>postEspec(`${apiPath}/free/saveOrUpdateFree`,params)
export const saveOrUpdateFreeProduct=params=>get(`${apiPath}/free/saveOrUpdateFreeProduct`,params)
export const saveOrUpdateFreeRule=params=>post(`${apiPath}/free/saveOrUpdateFreeRule`,params)
export const deleteFreeProduct=params=>get(`${apiPath}/free/deleteFreeProduct`,params)
export const deleteFreeRule=params=>get(`${apiPath}/free/deleteFreeRule`,params)
export const getCityList=params=>get(`${apiPath}/free/getCityList`,params)
export const getSalesTypeList=params=>get(`${apiPath}/free/getSalesTypeList`,params)
export const getPromotionList=params=>get(`${apiPath}/free/getPromotionList`,params)
export const getFreeTypeList=params=>get(`${apiPath}/free/getFreeTypeList`,params)
export const getVipAllList=params=>get(`${apiPath}/free/getVipAllList`,params)
export const getFree=params=>get(`${apiPath}/free/getFree`,params)
//购物车规则
export const getShoppingRule=params=>get(`${apiPath}/shoppingRule/getShoppingRule`,params)
export const getShoppingRuleList=params=>get(`${apiPath}/shoppingRule/getShoppingRuleList`,params)
export const deleteShoppingRule=params=>get(`${apiPath}/shoppingRule/deleteShoppingRule`,params)
export const saveShoppingRule=params=>get(`${apiPath}/shoppingRule/saveShoppingRule`,params)

//会员
export const testRedisExpire=params=>get(`${apiPath}/vip/testRedisExpire`,params)
export const getVipDayInfo=params=>get(`${apiPath}/vip/getVipDayInfo`,params)
export const setVipDayInfo=params=>get(`${apiPath}/vip/setVipDayInfo`,params)
export const conditionList=params=>get(`${apiPath}/vip/conditionList`,params)
export const getOptionConditionList=params=>get(`${apiPath}/vip/getOptionConditionList`,params)
export const getVipQrcodesDropList=params=>get(`${apiPath}/vip/getVipQrcodesDropList`,params)
export const saveCondition=params=>get(`${apiPath}/vip/saveCondition`,params)
export const delCondition=params=>get(`${apiPath}/vip/delCondition`,params)
export const rewardsList=params=>get(`${apiPath}/vip/rewardList`,params)
export const saveReward=params=>get(`${apiPath}/vip/saveReward`,params)
export const delReward=params=>get(`${apiPath}/vip/delReward`,params)
export const taskList=params=>get(`${apiPath}/vip/taskList`,params)
export const saveTask=params=>get(`${apiPath}/vip/saveTask`,params)
export const delTask=params=>get(`${apiPath}/vip/delTask`,params)
export const finishTask=params=>get(`${apiPath}/vip/finishTask`,params)
export const getOptionTaskList=params=>get(`${apiPath}/vip/getOptionTaskList`,params)
export const delTaskReward=params=>get(`${apiPath}/vip/delTaskReward`,params)
export const saveTaskReward=params=>get(`${apiPath}/vip/saveTaskReward`,params)
export const taskRewardList=params=>get(`${apiPath}/vip/taskRewardList`,params)
export const getVipDaySendRecord=params=>get(`${apiPath}/vip/getVipDaySendRecord`,params)
export const sendVipDayNotice=params=>get(`${apiPath}/vip/sendVipDayNotice`,params)
//会员权益信息
export const rightsList=params=>get(`${apiPath}/vip/rightsList`,params)
//会员权益保存
export const saveVipRights=params=>get(`${apiPath}/vip/saveVipRights`,params)
//会员权益删除
export const deleteVipRights=params=>get(`${apiPath}/vip/deleteVipRights`,params)
//会员权益权限修改
export const rightsChangeStatus=params=>get(`${apiPath}/vip/rightsChangeStatus`,params)
//会员权益修改
export const updateByIdLevel=params=>get(`${apiPath}/vip/updateByIdLevel`,params)
//商城评价管理
export const getEvaluateOrderListByPage=params=>get(`${apiPath}/evaluate/getEvaluateOrderListByPage`,params)
//商城订单评价详情
export const getEvaluateOrderDetail=params=>get(`${apiPath}/evaluate/getEvaluateOrderDetail`,params)
//商城订单商品评价信息
export const getEvaluateOrderProductList=params=>get(`${apiPath}/evaluate/getEvaluateOrderProductList`,params)
//分页商城订单商品评价信息
export const getEvaluateOrderProductListByPage=params=>get(`${apiPath}/evaluate/getEvaluateOrderProductListByPage`,params)

//运费管理
export const getMallFreightListByPage=params=>get(`${apiPath}/mallFreight/getMallFreightListByPage`,params)
export const getMallFreightDetail=params=>get(`${apiPath}/mallFreight/queryEditDataByFreightId`,params)
export const delMallFreight=params=>get(`${apiPath}/mallFreight/deleteFreightRules`,params)
export const saveMallFreightInfo=params=>post(`${apiPath}/mallFreight/saveMallFreightRules`,params)

//活动相关
export const sendCouponByBindCode=params=>get(`${apiPath}/activeManage/sendCouponByBindCode`,params)
//查询拼单配置列表
export const getCollageConfigList=params=>get(`${apiPath}/collageManage/getCollageConfigList`,params)
//保存拼单配置
export const saveCollageConfig=params=>post(`${apiPath}/collageManage/saveCollageConfig`,params)
//上传拼单图片
export const uploadCollageConfigBanner=`${baseUrl}/${apiPath}/collageManage/uploadCollageConfigBanner`
//设置拼单商品类型配置
export const setCollageConfigProduct=params=>get(`${apiPath}/collageManage/setCollageConfigProduct`,params)
//活动列表
export const getActiveList=params=>get(`${apiPath}/activeManage/getActiveList`,params)
//活动
export const getActive=params=>get(`${apiPath}/activeManage/getActive`,params)
//可用活动列表
export const getActiveForOption=params=>get(`${apiPath}/activeManage/getActiveForOption`,params)
//NPS统计
export const getNpsList=params=>get(`${apiPath}/nps/getList`,params)
//广告投放创建数据源
export const createAdDatasource=params=>get(`${apiPath}/paySerivce/createDatasource`,params)
//广告投放 数据源列表
export const getAdSourceList=params=>get(`${apiPath}/paySerivce/getAdSourceList`,params)
//登录用户关联公司可用活动列表
export const getActiveForOptionListApi=params=>get(`${apiPath}/activeManage/getActiveForOptionList`,params)
export const getActiveForOptionListByType=params=>get(`${apiPath}/activeManage/getActiveForOptionListByType`,params)
//二维码活动列表
export const getQrActiveList=params=>get(`${apiPath}/qrcodeManage/getQrcodeList`,params)
//活动优惠券，配送城市
export const getActiveParameter=params=>get(`${apiPath}/activeManage/getActiveParameter`,params)
//保存活动
export const saveActive=params=>get(`${apiPath}/activeManage/saveActive`,params)
//保存活动属性
export const saveActivePropertyApi=params=>get(`${apiPath}/property/saveActiveProperty`,params)
//删除活动属性
export const deleteActivePropertyApi=params=>get(`${apiPath}/property/deleteActiveProperty`,params)
//批量保存活动属性
export const saveActivePropertyListApi=params=>post(`${apiPath}/property/saveActivePropertyList`,params)
//活动属性列表
export const getActivePropertyList=params=>get(`${apiPath}/property/getActivePropertyList`,params)
//活动属性值属性列表
export const getActiveValuePropertyList=params=>get(`${apiPath}/property/getActiveValuePropertyList`,params)
//活动属性对象查询
export const getActiveProperty=params=>get(`${apiPath}/property/getActiveProperty`,params)
//活动上线检查
export const onlineCheckApi=params=>get(`${apiPath}/activeManage/activeOnlineCheck`,params)
//保存活动规则
export const saveActiveRuleApi=params=>get(`${apiPath}/activeManage/saveActiveRule`,params)
//查询活动规则
export const getActiveRuleListApi=params=>get(`${apiPath}/activeManage/getActiveRuleList`,params)
//删除活动规则
export const deleteActiveRuleApi=params=>get(`${apiPath}/activeManage/deleteActiveRule`,params)
//保存活动页面
export const saveActivePageApi=params=>get(`${apiPath}/activeManage/saveActivePage`,params)
//查询活动页面
export const getActivePageApi=params=>get(`${apiPath}/activeManage/getActivePage`,params)
//活动首页配置
export const saveActiveIndexApi=params=>get(`${apiPath}/activeManage/saveActiveIndex`,params)
//删除活动首页配置
export const deletActiveIndexApi=params=>get(`${apiPath}/activeManage/deletActiveIndex`,params)
//活动首页列表
export const getActiveIndexListApi=params=>get(`${apiPath}/activeManage/getActiveIndexList`,params)
// 获取打卡活动文案次数
export const getActiveCheckInConfig=params=>get(`${apiPath}/activeManage/getActiveCheckInConfig`,params)
// 保存打卡活动文案次数
export const saveActiveCheckInConfig=params=>get(`${apiPath}/activeManage/saveActiveCheckInConfig`,params)
//合成二维码
export const megerQrcodeApi=params=>get(`${apiPath}/qrcodeManage/megerQrcode`,params)
//copy活动
export const copyActive=params=>get(`${apiPath}/activeManage/copyActive`,params)
export const getOptionActiveList=params=>get(`${apiPath}/activeManage/getOptionActiveList`,params)
//保存二维码
export const saveQrcode=params=>get(`${apiPath}/qrcodeManage/saveQrcode`,params)
//发送优惠券、余额
export const getCashticketListByBindCodeApi=params=>get(`${apiPath}/activeCashticket/getCashticketListByBindCode`,params)

//获取所有可用优惠券
export const getEnableCashticketListApi=params=>get(`${apiPath}/cash/getEnableCashticketList`,params)
//保存绑定优惠券配置
export const saveActiveCouponApi=params=>get(`${apiPath}/activeCashticket/saveActiveCoupon`,params)
//保存绑定优惠券配置规则
export const saveCashticketRuleApi=params=>get(`${apiPath}/activeCashticket/saveCashticketRule`,params)
//删除优惠券配置规则
export const deleteCashticketRuleApi=params=>get(`${apiPath}/activeCashticket/deleteCashticketRule`,params)
//获起优惠券配置列表
export const getCashticketRuleListApi=params=>get(`${apiPath}/activeCashticket/getCashticketRuleList`,params)
//
export const getCashticketRuleTypeListApi=params=>get(`${apiPath}/activeCashticket/getCashticketRuleTypeList`,params)

//删除优惠券配置
export const deleteCouponConfigByBindCodeApi=params=>get(`${apiPath}/activeCashticket/deleteCouponConfigByBindCode`,params)
//根据bindCode 删除活动优惠券配置
export const deleteCouponConfigApi=params=>get(`${apiPath}/activeCashticket/deleteCouponConfig`,params)
//查询素材
export const getMediaforListApi=params=>get(`${apiPath}/mediaManage/getMediaforList`,params)
export const saveMediatApi=params=>get(`${apiPath}/scrmMaterial/saveMedia`,params)
export const getMiniMediaManaDataList=params=>get(`${apiPath}/scrmMaterial/getMiniMediaManaDataList`,params)
export const deleteQiWeiMedia=params=>get(`${apiPath}/scrmMaterial/deleteSiYuOwn`,params)


//活动人数查询
export const getUserSourceApi=params=>get(`${apiPath}/fit/getUserSource`,params)
//查询活动参与记录
export const getJoinRcordListApi=params=>get(`${apiPath}/fit/getJoinRcordList`,params)
//查询活动参与记录
export const prizeApi=params=>get(`${apiPath}/fit/prize`,params)
//查询邀请明细
export const getInviteDetailApi=params=>get(`${apiPath}/fit/getCustomerInvietList`,params)

//拼单相关
//保存拼单折扣配置
export const saveCollageDiscountConfig=params=>get(`${apiPath}/collageManage/saveCollageDiscountConfig`,params)
//查询拼单折扣列表
export const getCollageDiscountConfigList=params=>get(`${apiPath}/collageManage/getCollageDiscountConfigList`,params)
export const deleteCollageDiscountConfig=params=>get(`${apiPath}/collageManage/deleteCollageDiscountConfig`,params)

//保存拼单产品配置
export const saveCollageProductConfigList=params=>post(`${apiPath}/collageManage/saveCollageProductConfigList`,params)
//查询拼单产品列表
export const getCollageProductConfigList=params=>get(`${apiPath}/collageManage/getCollageProductConfigList`,params)
//删除拼单产品配置
export const deleteCollageProductConfig=params=>get(`${apiPath}/collageManage/deleteCollageProductConfig`,params)

//众筹相关
//众筹产品列表
export const getCrowdProductList=params=>get(`${apiPath}/crowdManage/getCrowdProductList`,params)
//保存众筹产品
export const saveCrowdProductConfig=params=>get(`${apiPath}/crowdManage/saveCrowdProductConfig`,params)
//众筹优惠券列表
export const getCrowdProductCouponList=params=>get(`${apiPath}/crowdManage/getCrowdProductCouponList`,params)
//保存众筹优惠券
export const saveCrowdCouponConfig=params=>post(`${apiPath}/crowdManage/saveCrowdCouponConfig`,params)
export const deleteCrowdCoupon=params=>get(`${apiPath}/crowdManage/deleteCrowdCoupon`,params)
//众筹订单日报表
export const getCrowdOrderList=params=>get(`${apiPath}/crowdManage/getCrowdOrderList`,params)

//众筹信息列表
export const getCrowActiveConfigList=params=>get(`${apiPath}/crowdManage/getCrowActiveConfigList`,params)
//众筹商品信息
export const getCrowdActiveProductList=params=>get(`${apiPath}/crowdManage/getCrowdActiveProductList`,params)

//编辑众筹商品信息
export const editCrowdActiveProductInfo=params=>get(`${apiPath}/crowdManage/editCrowdActiveProductInfo`,params)

//获取众筹配置信息
export const getCrowdConfigInfo=params=>get(`${apiPath}/crowdManage/getCrowdConfigInfo`,params)
//保存众筹首页配置
export const saveCrowdConfigInfo=params=>get(`${apiPath}/crowdManage/saveCrowdConfigInfo`,params)
//获取众筹评论
export const getCrowdFundingForumList=params=>get(`${apiPath}/crowdManage/getCrowdFundingForumList`,params)
//删除评论
export const deleteForum=params=>get(`${apiPath}/crowdManage/deleteForum`,params)
//保存众筹图片
export const saveCrowdImage =`${baseUrl}/zuul/lechun-cms//crowdManage/saveCrowdImage`
//获取众筹图片
export const getCrowdPicList=params=>get(`${apiPath}/crowdManage/getCrowdPicList`,params)
//删除众筹图片
export const deleCrowdPicInfo=params=>get(`${apiPath}/crowdManage/deleCrowdPicInfo`,params)
//
export const saveCrowdActiveInfo=params=>get(`${apiPath}/crowdManage/saveCrowdActiveInfo`,params)
//众筹成功发券
export const crowdSucc=params=>get(`${apiPath}/crowdManage/crowdSucc`,params)
//众筹失败退款
export const crowdFail=params=>get(`${apiPath}/crowdManage/crowdFail`,params)
//众筹过期补券
export const crowdExpireCompensate=params=>get(`${apiPath}/crowdManage/crowdExpireCompensate`,params)
//商品售罄补券
export const crowdSoldOutCompensate=params=>get(`${apiPath}/crowdManage/crowdSoldOutCompensate`,params)

//团购相关
// 保存团购配置
export const saveGrouponConfigApi=params=>get(`${apiPath}/grouponManage/saveGrouponConfig`,params)
// 查询团购配置
export const getGrouponConfigApi=params=>get(`${apiPath}/grouponManage/getGrouponConfig`,params)
//查询团购列表
export const getGrouponListApi=params=>get(`${apiPath}/grouponManage/getGrouponList`,params)
//设置成团
export const setGrouponPrizeApi=params=>get(`${apiPath}/grouponManage/setPrize`,params)
//查看团购明细
export const getGrouponDtailList=params=>get(`${apiPath}/grouponManage/getGrouponDtailList`,params)
// 后台开团
export const creatGroup=params=>post(`${apiPath}/grouponManage/creatGroup`,params)
// 社区团购分销连接
export const getLink=params=>get(`${apiPath}/grouponManage/getLink`,params)
export const downloadJoinOrder = `${baseUrl}/${apiPath}/grouponManage/downloadJoinOrder`


//可售卖量配置管理
export const getSalesManageNumList=params=>get(`${apiPath}/productSales/getProductSalesListByPage`,params)
export const saveSalesManageNumItem=params=>get(`${apiPath}/productSales/saveProductInfo`,params)

//短连接
export const getShortUrlListApi=params=>get(`${apiPath}/shortlink/getShortLinkList`,params)
export const saveShortLinkApi=params=>get(`${apiPath}/shortlink/getShortLink`,params)
export const deleteShortLinkApi=params=>get(`${apiPath}/shortlink/delete`,params)

//短信/邮件/外部连接 跳转小程序
export const saveUrlSchemeApi=params=>post(`${apiPath}/urlScheme/saveUrlScheme`,params)
export const getUrlSchemeListApi=params=>get(`${apiPath}/urlScheme/getUrlSchemeList`,params)
export const deleteUrlSchemeApi=params=>get(`${apiPath}/urlScheme/delete`,params)

//小商店
export const register=params=>post(`${apiPath}/minishop/register`,params)// 注册
export const getSkuCatList=params=>get(`${apiPath}/minishop/getSkuCatList`,params)// 三级类目列表
export const getAllSkuCatList=params=>get(`${apiPath}/minishop/getAllSkuCatList`,params)// 所有类目列表
export const audit_category=params=>post(`${apiPath}/minishop/audit_category`,params)// 上传类目
export const get_audit_category=params=>get(`${apiPath}/minishop/get_audit_category`,params)// 查询类目审核
export const audit_Brand=params=>post(`${apiPath}/minishop/audit_Brand`,params)// 上传品牌
export const get_brand_list=params=>get(`${apiPath}/minishop/get_brand_list`,params)// 查询品牌列表
export const getminiProductList=params=>get(`${apiPath}/minishop/getProductList`,params)//商品列表
export const setProductOn=params=>get(`${apiPath}/minishop/setProductOn`,params)//商品上架
export const setProductOff=params=>get(`${apiPath}/minishop/setProductOff`,params)//商品下架
export const deletProduct=params=>get(`${apiPath}/minishop/deletProduct`,params)//商品删除
//EDB手动同步接口
export const syncEdbOrder=params=>get(`${apiPath}/order/edbOrderSyncQuartz`,params)
export const unsyncEDBOrders=params=>get(`${apiPath}/order/unsyncEDBOrders`,params)
export const omsOrderSyncQuartz=params=>get(`${apiPath}/order/omsOrderSyncQuartz`,params)
export const omsOrderSyncStatus=params=>get(`${apiPath}/order/omsOrderSyncStatus`,params)
export const unsyncOMSOrders=params=>get(`${apiPath}/order/unsyncOMSOrders`,params)
export const fixBalancePay=params=>get(`${apiPath}/order/fixBalancePay`,params)
export const getOutStockList=params=>get(`${apiPath}/order/getOutStockList`,params)

//预约提醒
export const getReserveList=params=>get(`${apiPath}/reserveManage/getReserveList`,params)
export const sendReserveMessage=params=>get(`${apiPath}/reserveManage/sendReserveMessage`,params)
export const sendPreview=params=>get(`${apiPath}/reserveManage/sendPreview`,params)
export const sendReserveCoupon=params=>get(`${apiPath}/reserveManage/sendReserveCoupon`,params)
export const sendReserveCoupon2=params=>get(`${apiPath}/reserveManage/sendCoupon`,params)
export const exportCustomerList=`${baseUrl}/${apiPath}/reserveManage/exportCustomer`

//退款失败信息
export const getOrderRefundFailRecordList=params=>get(`${apiPath}/refundFailRecord/getOrderRefundFailRecordList`,params)
export const refundPay=params=>get(`${apiPath}/refundFailRecord/refundPay`,params)
export const modifyRefundNum=params=>get(`${apiPath}/refundFailRecord/modifyRefundNum`,params)
export const deleteRefundInfo=params=>get(`${apiPath}/refundFailRecord/deleteRefundInfo`,params)
export const importPaperAnswer=`${baseUrl}/${apiPath}/organization/importPaperAnswer`

export const importAaRrrData=`${baseUrl}/${apiPath}/mallAarrr/importAaRrrData`

//导出收付款数据
export const getExportDataApi = `${baseUrl}/${apiPath}/order/getExportData`//收付款导出

//客户管理
//获取用户列表
export const getCustomerList=params=>get(`${apiPath}/customer/getCustomerList`,params)
//保存客服用户接入记录
export const saveCusertomerUserServiceApi=params=>get(`${apiPath}/customer/saveCusertomerUserService`,params)
//获取用户信息
export const getCustomerInfo=params=>get(`${apiPath}/customer/getCustomerInfo`,params)
//获取用户关注信息
export const getCustomerFollowInfo=params=>get(`${apiPath}/customer/getCustomerOpenIdList`,params)
//获取用户地址列表
export const getCustomerAddressListInfo=params=>get(`${apiPath}/customer/getCustomerAddressList`,params)
//获取用户余额账户信息
export const getTotalBalanceApi=params=>get(`${apiPath}/customerBalance/getTotalBalance`,params)
//用户变动记录明细
export const getUserBalanceDetailApi=params=>get(`${apiPath}/customerBalance/getUserBalanceDetail`,params)
//增加余额
export const increaseManualApi=params=>post(`${apiPath}/customerBalance/increaseManual`,params)
//减少余额
export const reduceManualApi=params=>post(`${apiPath}/customerBalance/reduceManual`,params)
//储值退款
export const refundCharge=params=>get(`${apiPath}/customerBalance/refundCharge`,params)

//获取省市区列表
export const getCustomerAddressCityAreaList=params=>get(`${apiPath}/customer/getProvinceCityAreaByErp`,params)
export const getCustomerAddressTypeList=params=>get(`${apiPath}/customer/getAddressType`,params)
//获取用户订单列表
export const getCustomerOrderListInfo=params=>get(`${apiPath}/customer/getCustomerOrderList`,params)
export const changeCustomerOrderState=params=>get(`${apiPath}/order/updateOrderStatus`,params)
//获取用户优惠券列表
export const getCustomerCouponListInfo=params=>get(`${apiPath}/cash/getCashticketList`,params)
export const CustomerCouponDisable=params=>get(`${apiPath}/cash/updateCashticketStatus`,params)
//用户地址保存
export const customerAddressSubmit=params=>get(`${apiPath}/customer/addAddress`,params)
//用户修改手机号保存
export const customerPhoneSubmit=params=>get(`${apiPath}/customer/saveMobile`,params)
//获取会员信息
export const customerVipCenterInfo=params=>get(`${apiPath}/customer/centerInfo`,params)
//更新会员等级
export const updateCustomerVipCenterLevel=params=>get(`${apiPath}/customer/updateVipLevel`,params)
//更新会员缓存
export const updateCustomerVipCenterCache=params=>get(`${apiPath}/customer/deleteUserVipInfoCache`,params)

//礼品卡
export const findGiftCardBatches=params=>get(`${apiBalancePath}/giftCard/findGiftCardBatches`,params)
//分页查询券码信息
export const findGiftCards=params=>get(`${apiBalancePath}/giftCard/findGiftCards`,params)
//导出批次号
export const exportGiftCards=params=>get(`${apiBalancePath}/giftCard/exportGiftCards`,params)
//生成一批礼品卡
export const generateGiftCardBatch=params=>get(`${apiBalancePath}/giftCard/generateGiftCardBatch`,params)
//删除一批礼品卡
export const delGiftCardBatch=params=>get(`${apiBalancePath}/giftCard/delGiftCardBatch`,params)
//作废某一批次礼品卡
export const cancelGiftCardBatch=params=>get(`${apiBalancePath}/giftCard/cancelGiftCardBatch`,params)
//作废某张礼品卡
export const invalidCard=params=>get(`${apiBalancePath}/giftCard/invalidCard`,params)


//分页查询
export const findStorageCard=params=>get(`${apiBalancePath}/storageCard/findStorageCard`,params)
//新增储值卡
export const saveStorageCard=params=>get(`${apiBalancePath}/storageCard/saveStorageCard`,params)
//更改状态
export const invalidStorageCard=params=>get(`${apiBalancePath}/storageCard/invalidCard`,params)
//验证标题
export const validationStorageInfo=params=>get(`${apiBalancePath}/storageCard/validationStorageInfo`,params)
//初始化导入数据
export const initData=params=>get(`${apiBalancePath}/storageCard/importCards`,params)

export const getStorageCardByProId=params=>get(`${apiBalancePath}/storageCard/getStorageCardByProId`,params)
export const findSumDaily=params=>get(`${apiBalancePath}/sumDaily/find`,params)

//订单查询
export const queryOrderList=params=>get(`${apiPath}/order/getOrderList`,params)
//配送订单查询
export const shippingOrderList=params=>post(`${apiPath}/order/getShippOrderList`,params)
//隐藏订单
export const hideOrder=params=>get(`${apiPath}/order/hideOrder`,params)
//有数订单校验
export const youShuOrderSum=params=>get(`${apiPath}/order/youShuOrderSum`,params)
//添加所有冷链商品到满减活动
export const addFullCutAllColdProducts=params=>get(`${apiPath}/fullcut/addFullCutAllColdProducts`,params)
//短信测试
export const sendSmsApi=params=>post(`${apiBaseservicePath}/sms/send`,params)
export const getMongateBalanceApi=params=>post(`${apiBaseservicePath}/sms/getMongateBalance`,params)
//基础服务-短信 模板列表
export const getTemplateListApi=params=>get(`${apiBaseservicePath}/smsConfig/getTemplateList`,params)
//基础服务-短信 应用列表
export const getAppListApi=params=>get(`${apiBaseservicePath}/smsConfig/getAppList`,params)
//基础服务-短信 应用保存
export const saveAppApi=params=>post(`${apiBaseservicePath}/smsConfig/saveApp`,params)
//基础服务-短信 模板保存
export const saveTemplateApi=params=>post(`${apiBaseservicePath}/smsConfig/saveTemplate`,params)
//保存用户组
export const saveGroupApi=params=>get(`${apiBaseservicePath}/userGroup/saveGroup`,params)
//获取用户组列表
export const getUserGroupListApi=params=>get(`${apiBaseservicePath}/userGroup/getUserGroupList`,params)
//删除用户组
export const deleteGroupApi=params=>get(`${apiBaseservicePath}/userGroup/deleteGroup`,params)
//删除用户组用户
export const deleteUserApi=params=>get(`${apiBaseservicePath}/userGroup/deleteUser`,params)
//任务列表
export const getTaskListApi=params=>get(`${apiBaseservicePath}/taskMessage/getTaskList`,params)
//获取任务
export const getTaskApi=params=>get(`${apiBaseservicePath}/task/getTask`,params)
//保存任务
export const saveTaskApi=params=>get(`${apiBaseservicePath}/taskMessage/saveTask`,params)
//保存任务-新
export const saveTaskApiNew=params=>get(`${apiBaseservicePath}/task/saveTask`,params)
//任务审核
export const auditTaskApi=params=>get(`${apiBaseservicePath}/taskMessage/auditTask`,params)
//任务保存关联参数
export const getTaskParaListApi=params=>get(`${apiBaseservicePath}/taskMessage/getTaskParaList`,params)
//消息预览
export const previewApi=params=>get(`${apiBaseservicePath}/taskMessage/preview`,params)
//用户导入
export const uploadUserApi=`${baseUrl}/${apiBaseservicePath}/userGroup/upload`
//下载用户导入模板
export const downLoadUserApi=`${baseUrl}/${apiBaseservicePath}/userGroup/downLoad`
//更新用户组人数
export const updateGroupNumApi=params=>get(`${apiBaseservicePath}/userGroup/updateGroupNum`,params)
//删除任务
export const deleteTaskApi=params=>get(`${apiBaseservicePath}/taskMessage/deleteTask`,params)
//任务取消
export const cancelApi=params=>get(`${apiBaseservicePath}/taskMessage/cancel`,params)
//立即发送
export const pullUserToRedisByTaskIdApi=params=>get(`${apiBaseservicePath}/taskMessage/pullUserToRedisByTaskId`,params)
//批量保存用户规则
export const saveGroupRuleListApi=params=>post(`${apiBaseservicePath}/groupRule/saveGroupRuleList`,params)
//查询用户标签
export const getTagListApi=params=>get(`${apiBaseservicePath}/groupRule/getTagList`,params)
//查询用户标签
export const getTagListVoListApi=params=>get(`${apiBaseservicePath}/groupRule/getTagListVoList`,params)
//查询用户标签
export const getRuleListApi=params=>get(`${apiBaseservicePath}/groupRule/getRuleList`,params)
//查询标签类型规则
export const getTagTypeRuleListApi=params=>get(`${apiBaseservicePath}/groupRule/getTagTypeRuleList`,params)
//查询组规则列表
export const getMyTagRuleListApi=params=>get(`${apiBaseservicePath}/groupRule/getMyTagRuleList`,params)
//查询Tag列表
export const saveTagApi=params=>get(`${apiBaseservicePath}/groupRule/saveTag`,params)
//删除Tag
export const deleteTagApi=params=>get(`${apiBaseservicePath}/groupRule/deleteTag`,params)

//查询标签类型规则选项
export const getTagOptionListByTagIdApi=params=>get(`${apiBaseservicePath}/groupRule/getTagOptionListByTagId`,params)
//查询标签类型规则选项
export const getTagOptionApi=params=>get(`${apiBaseservicePath}/groupRule/getTagOption`,params)

//保存消息接收过滤规则
export const saveMessageLimitApi=params=>get(`${apiBaseservicePath}/taskMessage/saveMessageLimit`,params)
//防干扰配置列表
export const getMessageLimitListApi=params=>get(`${apiBaseservicePath}/taskMessage/getMessageLimitList`,params)
//删除防干扰配置
export const deleteMessageLimitApi=params=>get(`${apiBaseservicePath}/taskMessage/deleteMessageLimit`,params)
//删除tag 规则
export const deleteRuleTypeApi=params=>get(`${apiBaseservicePath}/ruleType/delete`,params)
//tag 列表
export const getRuleTypeListApi=params=>get(`${apiBaseservicePath}/ruleType/getRuleTypeList`,params)
//保存tag ruleType
export const saveRuleTypeApi=params=>get(`${apiBaseservicePath}/ruleType/save`,params)


//添加所有常温商品到满减活动
export const addFullCutAllNomalProducts=params=>get(`${apiPath}/fullcut/addFullCutAllNomalProducts`,params)
//协作办公
//榜单
export const getRankingListApi=params=>get(`${apiPath}/vote/getRankingList`,params)
//保存点赞,取消点赞
export const saveVoteApi=params=>post(`${apiPath}/vote/saveVote`,params)


//周报

export const getCooperativeList=params=>get(`${apiPath}/organization/getPaperPageList`,params)
export const getPaperPage=params=>get(`${apiPath}/organization/getPaperPage`,params)
export const getCooperativeAllUserInterviewList=params=>get(`${apiPath}/organization/getPublicPapers`,params)
export const getCooperativeQuesList=params=>get(`${apiPath}/organization/getPaperAnswerList`,params)
export const saveCooperativeQues=params=>post(`${apiPath}/organization/savePaperAnswer`,params)
export const uploadCooperativeFile=`${baseUrl}/zuul/lechun-cms/orgUserInterview/getFilePath`
export const getCooperativeBankList=params=>get(`${apiPath}/vote/getRankingList`,params)
export const getCooperativeCallMe=params=>get(`${apiPath}/organization/relationMe`,params)
export const cooperativeLike=params=>post(`${apiPath}/vote/saveVote`,params)
export const getCooperativeAllUserList=params=>get(`${apiPath}/user/getUserListForDorpbox`,params)
export const getCooperativeAllList=params=>get(`${apiPath}/organization/lookPaperAnswer`,params)
export const getCooperativeAllQuesList=params=>get(`${apiPath}/question/getQuestionList`,params)
export const getCooperativeWeekInfo=params=>get(`${apiPath}/organization/getPeriod`,params)
export const cooperativeComment=params=>get(`${apiPath}/vote/getVoteList`,params)
export const getAllResourceGroups=params=>get(`${apiPath}/resource/getAllResourceGroups`,params)
export const getResourceVisibleGroups=params=>get(`${apiPath}/resource/getResourceVisibleGroups`,params)
export const cooperativeCallBackSave=params=>get(`${apiPath}/organization/saveAnswer`,params)
export const cooperativePrizeList=params=>get(`${apiPath}/organization/getBonusesList`,params)
export const cooperativePrizeDetail=params=>get(`${apiPath}/organization/getPaperBonusDetaiList`,params)
export const cooperativeMyPrizeList=params=>get(`${apiPath}/organization/getBonusesListByUser`,params)
export const cooperativeMyPrizeBonusesDate=params=>get(`${apiPath}/organization/getBonusesDate`,params)
export const cooperativeMyPrizeDownload = `${baseUrl}/${apiPath}/organization/downloadBonuses`
export const getQuarterKpiQues = params=>get(`${apiPath}/kpi/getKpis`,params)
export const delQuarterKpiQues = params=>get(`${apiPath}/kpi/deleteKpi`,params)
export const getQuarterKpiQuesId = params=>get(`${apiPath}/kpi/BuildKpiId`,params)
export const saveQuarterKpiQues=params=>post(`${apiPath}/kpi/saveKpi`,params)
export const getKpiMonthsTotal=params=>post(`${apiPath}/kpi/getKpiMonthsTotal`,params)
export const getKpiMonthRanking=params=>post(`${apiPath}/kpi/getKpiMonthRanking`,params)
export const getKrTableTitle=params=>post(`${apiPath}/kpi/getKrTableTitle`,params)
export const saveCheckWeekAfterWeek=params=>post(`${apiPath}/organization/setWeekAfterWeekFinishStatus`,params)
export const modifyPaperAnswerRelationSort=params=>post(`${apiPath}/organization/modifyPaperAnswerRelationSort`,params)
export const saveModityPaperStatus=params=>post(`${apiPath}/organization/modityPaperStatus`,params)
export const savemodityWeekAfterWeek=params=>post(`${apiPath}/organization/modityWeekAfterWeek`,params)
export const saveRemarkInfo=params=>post(`${apiPath}/organization/saveRemarkInfo`,params)
export const saveIsDissentInfo=params=>post(`${apiPath}/organization/saveIsDissentInfo`,params)
export const saveKpiRemark=params=>post(`${apiPath}/kpi/saveKpiRemark`,params)
export const updateFinishFlag=params=>post(`${apiPath}/kpi/updateFinishFlag`,params)
export const getWeekEndUnfinshList=params=>post(`${apiPath}/organization/getWeekEndUnfinshList`,params)
export const getWeekEndfinshList=params=>post(`${apiPath}/organization/getWeekEndfinshList`,params)
export const returnQues=params=>post(`${apiPath}/organization/returnQues`,params)
export const savePaperRead=params=>post(`${apiPath}/organization/savePaperRead`,params)
export const getWeekTaskList=params=>post(`${apiPath}/organization/getWeekTaskList`,params)
export const getOKRList=params=>post(`${apiPath}/organization/getOKRList`,params)
export const importOKR=`${baseUrl}/${apiPath}/organization/importOKR`
export const downloadExcelWeek = `${baseUrl}/${apiPath}/organization/downloadExcelWeek`//收付款导出
export const saveAnswerRelation=params=>post(`${apiPath}/organization/saveAnswerRelation`,params)

//协作办公管理控制
export const findQuestionClass=params=>post(`${apiPath}/questionClass/findQuestionClass`,params)
export const findQuestionClassList=params=>post(`${apiPath}/questionClass/findQuestionClassList`,params)
export const saveQuestionClass=params=>post(`${apiPath}/questionClass/saveQuestionClass`,params)
export const getQuesTimeout=params=>post(`${apiPath}/questionClass/getTimeout`,params)
export const saveQuestionClassTimeout=params=>post(`${apiPath}/questionClass/saveQuestionClassTimeout`,params)
export const getTimeoutSpecialUsers=params=>post(`${apiPath}/questionClass/getTimeoutSpecialUsers`,params)
export const saveTimeoutSpecialUsers=params=>post(`${apiPath}/questionClass/saveTimeoutSpecialUsers`,params)
export const findPeriodList=params=>post(`${apiPath}/periodManage/findPeriodList`,params)
export const buildPaper=params=>post(`${apiPath}/organization/buidPaper`,params)
export const getSubordinateUnConfirmReport=params=>post(`${apiPath}/organization/getSubordinateUnConfirmReport`,params)
export const rebuildWeekPaperThankResult=params=>post(`${apiPath}/questionClass/rebuildWeekPaperThankResult`,params)

export const importWeekJob=`${baseUrl}/${apiPath}/organization/importWeekJob`

//对账
export const getOrderBillInfo=params=>get(`${apiPath}/cmbBankBill/getOrderBillInfo`,params)
export const orderBill=params=>get(`${apiPath}/cmbBankBill/downloadBill`,params)
export const readCsv=params=>get(`${apiPath}/cmbBankBill/readCsv`,params)
export const billResult=params=>get(`${apiPath}/cmbBankBill/billResult`,params)
export const deletebillResult=params=>get(`${apiPath}/billResult/deleteByTradeNo`,params)


//删除所有满减商品
export const delFullCutAllProducts=params=>get(`${apiPath}/fullcut/delFullCutAllProducts`,params)
//奶卡订单日志
export const getCardPlanLog=params=>get(`${apiPath}/prepay/getCardPlanLog`,params)

//认养一头牛
export const cardBatches=params=>get(`${apiPath}/prepay/cardBatches`,params)
export const viewCards=params=>get(`${apiPath}/prepay/viewCards`,params)
export const addBatch=params=>get(`${apiPath}/prepay/addBatch`,params)
export const delBatch=params=>get(`${apiPath}/prepay/delBatch`,params)
export const addBatchCards=params=>get(`${apiPath}/prepay/addBatchCards`,params)
export const getPlanListApi=params=>get(`${apiPath}/prepay/getPrepayCardDetailVoList`,params)
export const getCarListApi=params=>get(`${apiPath}/prepay/getPrepayCardVoList`,params)
//下载计划
export const downCardPlanApi = `${baseUrl}/${apiPath}/prepay/downloadCardPlan`
export const downloadExcelCooperative = `${baseUrl}/${apiPath}/organization/getExportData`
//获取卡渠道列表
export const getPrepayOrderSourceNameListApi=params=>get(`${apiPath}/prepay/getPrepayOrderSourceNameList`,params)
//卡禁用
export const disabledCardApi=params=>get(`${apiPath}/prepay/disabledCard`,params)
//卡延期
export const setCardExpireTime=params=>get(`${apiPath}/prepay/setCardExpireTime`,params)
//点卡商品
export const getCardItemList=params=>get(`${apiPath}/prepay/getCardItemList`,params)
export const saveCardItem=params=>get(`${apiPath}/prepay/saveCardItem`,params)
export const  deleteCardItem=params=>get(`${apiPath}/prepay/deleteCardItem`,params)
//得到分享列表
export const getShareList=params=>get(`${apiPath}/distributor/getSharePageList`,params)
export const getShare=params=>get(`${apiPath}/distributor/getShare`,params)
export const saveShare=params=>get(`${apiPath}/distributor/saveShare`,params)
export const deleteShare=params=>get(`${apiPath}/distributor/deleteShare`,params)
//得到分销员分组列表
export const getDistributorGroupPageList=params=>get(`${apiPath}/distributor/getGroupPageList`,params)
export const getDistributorGroup=params=>get(`${apiPath}/distributor/getGroup`,params)
export const saveDistributorGroup=params=>get(`${apiPath}/distributor/saveGroup`,params)
export const deleteDistributorGroup=params=>get(`${apiPath}/distributor/deleteGroup`,params)
export const getDistributorGroupOption=params=>get(`${apiPath}/distributor/getGroupOption`,params)
export const getQiyeWeixinFollowUsers=params=>get(`${apiPath}/distributor/getQiyeWeixinFollowUsers`,params)
export const getQiyeWeixinFollowUserContacts=params=>get(`${apiPath}/distributor/getQiyeWeixinFollowUserContacts`,params)
export const sendInvitePageMsg=params=>get(`${apiPath}/distributor/sendInvitePageMsg`,params)

//得到分销员列表
export const getDistributorPageList=params=>get(`${apiPath}/distributor/getDistributorPageList`,params)
export const getDistributor=params=>get(`${apiPath}/distributor/getDistributor`,params)
export const saveDistributor=params=>get(`${apiPath}/distributor/saveDistributor`,params)
export const getDistributorOption=params=>get(`${apiPath}/distributor/getDistributorOption`,params)

//分销员素材
export const getDistributionMediaList=params=>get(`${apiPath}/distributor/getDistributionMediaList`,params)
export const getDistributionMediaStaffList=params=>get(`${apiPath}/distributor/getDistributionMediaStaffList`,params)
export const saveDistributionMedia=params=>get(`${apiPath}/distributor/saveDistributionMedia`,params)
export const saveDistributionStaffMedia=params=>get(`${apiPath}/distributor/saveDistributionStaffMedia`,params)
export const getDistributionMedia=params=>get(`${apiPath}/distributor/getDistributionMedia`,params)
export const saveBatchMediaStaff=params=>get(`${apiPath}/distributor/saveBatchMediaStaff`,params)
export const deleteZhichiMedia=params=>get(`${apiPath}/distributor/deleteMedia`,params)
export const deleteMediaStaff=params=>get(`${apiPath}/distributor/deleteMediaStaff`,params)
export const getDistributorLinkVoList=params=>get(`${apiPath}/distributor/getDistributorLinkVoList`,params)


//企微标签
export const getTagList=params=>get(`${apiPath}/tag/getTagList`,params)
export const getTagGroupList=params=>get(`${apiPath}/tag/getTagGroupList`,params)
export const getTagCustomerList=params=>post(`${apiPath}/tag/getTagCustomerList`,params)
export const saveTagItem=params=>post(`${apiPath}/tag/saveTagItem`,params)
export const saveTag=params=>post(`${apiPath}/tag/saveTag`,params)
export const pullTag=params=>post(`${apiPath}/tag/pullTag`,params)
export const deleteTag=params=>get(`${apiPath}/tag/deleteTag`,params)
export const getTagRuleGroupList=params=>get(`${apiPath}/tag/getTagRuleGroupList`,params)
export const saveRuleGroup=params=>get(`${apiPath}/tag/saveRuleGroup`,params)
export const deletRuleGroup=params=>get(`${apiPath}/tag/deletRuleGroup`,params)
export const getTagRuleList=params=>get(`${apiPath}/tag/getTagRuleList`,params)
export const saveRule=params=>get(`${apiPath}/tag/saveRule`,params)
export const deletRule=params=>get(`${apiPath}/tag/deletRule`,params)
export const getLaunchCode=params=>get(`${apiPath}/tag/getLaunchCode`,params)

//私域妈妈 线下卖场及促销员
export const getOffLineShopList=params=>get(`${apiPath}/distributor/getOffLineShopList`,params)
export const getSalePersionList=params=>get(`${apiPath}/distributor/getSalePersionList`,params)
export const saveOffLineShop=params=>get(`${apiPath}/distributor/saveOffLineShop`,params)
export const saveSalePersion=params=>get(`${apiPath}/distributor/saveSalePersion`,params)
export const deleteOffLineShop=params=>get(`${apiPath}/distributor/deleteOffLineShop`,params)
export const deleteShopSalePersion=params=>get(`${apiPath}/distributor/deleteShopSalePersion`,params)

export const getDistributionInvitePageList=params=>get(`${apiPath}/distributor/getDistributionInvitePageList`,params)
export const getDistributionOrderPageList=params=>get(`${apiPath}/distributor/getDistributionOrderPageList`,params)
export const importKpi=`${baseUrl}/${apiPath}/kpi/importKpi`
export const importOkr=`${baseUrl}/${apiPath}/kpi/importOkr`
export const importOkrDingding=`${baseUrl}/${apiPath}/kpi/importOkrWithDingding`
// 活码
export const findQrList=params=>get(`${apiPath}/qr/findQrList`,params)
export const getQr=params=>get(`${apiPath}/qr/getQr`,params)
export const addOrEditQr=params=>get(`${apiPath}/qr/addOrEditQr`,params)
export const delQr=params=>get(`${apiPath}/qr/delQr`,params)
export const onoff=params=>get(`${apiPath}/qr/onoff`,params)
export const findQrSubList=params=>get(`${apiPath}/qr/findQrSubList`,params)
export const addOrEditQrSub=params=>get(`${apiPath}/qr/addOrEditQrSub`,params)
export const delQrSub=params=>get(`${apiPath}/qr/delQrSub`,params)
export const downloadQR = `${baseUrl}/${apiPath}/qr/downloadQR`
export const downloadSubQR = `${baseUrl}/${apiPath}/qr/downloadSubQR`
//得到分销商品分成
export const getDistributorItemList=params=>get(`${apiPath}/distributor/getDistributorItemList`,params)
export const getSingleDistributorItem=params=>get(`${apiPath}/distributor/getSingleDistributorItem`,params)
export const saveDistributorItem=params=>post(`${apiPath}/distributor/saveDistributorItem`,params)
export const initDistributorItem=params=>get(`${apiPath}/distributor/initDistributorItem`,params)

//监控系统
export const findErrorLogs=params=>get(`${apiMonitorPath}/errorLog/findLogs`,params)
export const findAccessLogs=params=>get(`${apiMonitorPath}/accessLog/findLogs`,params)
export const findAvgLogs=params=>post(`${apiMonitorPath}/accessLog/findAvgLogs`,params)
export const findWaitLogs=params=>get(`${apiMonitorPath}/accessLog/findWaitLogs`,params)
export const getActionLogPerSecond=params=>get(`${apiMonitorPath}/accessLog/getActionLogPerSecond`,params)
export const getActionCountPerSecond=params=>get(`${apiMonitorPath}/accessLog/getActionCountPerSecond`,params)

//回收计划
export const productList=params=>get(`${apiPath}/reunion/productList`,params)
export const saveProdcts=params=>get(`${apiPath}/reunion/saveProdcts`,params)
export const deleteProduct=params=>get(`${apiPath}/reunion/deleteProduct`,params)
export const copyProdcts=params=>get(`${apiPath}/reunion/copyProdcts`,params)
export const saveReunionSite=params=>get(`${apiPath}/reunion/saveReunionSite`,params)
export const getReunionSiteEntity=params=>get(`${apiPath}/reunion/getReunionSiteEntity`,params)
export const getReunionSiteList=params=>get(`${apiPath}/reunion/getReunionSiteList`,params)
export const deleteReunionSite=params=>get(`${apiPath}/reunion/deleteReunionSite`,params)
export const saveReunionActiveProperty=params=>post(`${apiPath}/reunion/saveReunionActivePropertyList`,params)
export const getVerificationReunionOrderList=params=>get(`${apiPath}/reunion/getVerificationReunionOrderList`,params)
export const VerificationReunionOrder=params=>get(`${apiPath}/reunion/VerificationReunionOrder`,params)
export const cancelReunionOrder=params=>get(`${apiPath}/reunion/cancelReunionOrder`,params)
export const importOrderRecoverProducts=`${baseUrl}/${apiPath}/reunion/importOrderRecoverProducts`
export const modifyReunionOrderArriveTime=params=>get(`${apiPath}/reunion/modifyReunionOrderArriveTime`,params)

export const saveStock=params=>get(`${apiPath}/reunion/saveStock`,params)
export const getStockList=params=>get(`${apiPath}/reunion/getStockList`,params)

//天猫优惠券打标签
export const listCoupon=params=>get(`${apiPath}/tmallCouponTag/listCoupon`,params)
export const listTags=params=>get(`${apiPath}/tmallCouponTag/listTags`,params)
export const tagCoupon=params=>get(`${apiPath}/tmallCouponTag/tagCoupon`,params)
//小商店物流公司管理
export const getMiniShopLogisticsList=params=>get(`${apiPath}/logistics/getMiniShopLogisticsList`,params)
export const saveLogisticsLink=params=>get(`${apiPath}/logistics/saveLogisticsLink`,params)
export const getLogisticsList=params=>get(`${apiPath}/logistics/getLogisticsList`,params)
export const getMiniSchemeSystem=params=>get(`${apiPath}/urlScheme/getMiniSchemeSystem`,params)
export const getMiniSchemeSystemByPara=params=>get(`${apiPath}/urlScheme/getMiniSchemeSystemByPara`,params)
export const getPageLinkOption=params=>get(`${apiPath}/pageLink/getPageLinkOption`,params)
export const templateSubcriptGetList=params=>get(`${apiPath}/templateSubcript/getList`,params)
export const templateSubcriptGetSingle=params=>get(`${apiPath}/templateSubcript/getSingle`,params)
export const templateSubcriptSave=params=>get(`${apiPath}/templateSubcript/save`,params)
export const templateSubcriptDelete=params=>get(`${apiPath}/templateSubcript/delete`,params)
export const getSubscribeTemplateMessageList=params=>get(`${apiPath}/wexinMessage/getSubscribeTemplateMessageList`,params)
//抽奖
export const luckydraw_list=params=>get(`${apiPath}/luckydraw/list`,params)
export const luckydraw_get=params=>get(`${apiPath}/luckydraw/get`,params)
export const luckydraw_add=params=>get(`${apiPath}/luckydraw/add`,params)
export const luckydraw_delete=params=>get(`${apiPath}/luckydraw/delete`,params)
export const luckydraw_prizeList=params=>get(`${apiPath}/luckydraw/prizeList`,params)
export const luckydraw_getPrize=params=>get(`${apiPath}/luckydraw/getPrize`,params)
export const luckydraw_addPrize=params=>get(`${apiPath}/luckydraw/addPrize`,params)
export const luckydraw_deletePrize=params=>get(`${apiPath}/luckydraw/deletePrize`,params)
export const luckydraw_getDrawUserList=params=>get(`${apiPath}/luckydraw/getDrawUserList`,params)
export const setDrawPrizeFixUser=params=>get(`${apiPath}/luckydraw/setDrawPrizeFixUser`,params)
export const getConditionOptions=params=>get(`${apiPath}/luckydraw/getConditionOptions`,params)
export const openLuckyDraw=params=>get(`${apiPath}/luckydraw/openLuckyDraw`,params)
export const setLineOffTakeDrawSuccess=params=>get(`${apiPath}/luckydraw/setLineOffTakeDrawSuccess`,params)
export const messageBlackList=params=>get(`${apiPath}/messageBlackList/list`,params)
export const messageBlackEntity=params=>get(`${apiPath}/messageBlackList/getSingle`,params)

export const messageBlackSave=params=>get(`${apiPath}/messageBlackList/save`,params)
export const getContactPageList=params=>get(`${apiBiPath}/contact/getContactPageList`,params)
export const saveContact=params=>get(`${apiBiPath}/contact/saveContact`,params)
export const getContactEntity=params=>get(`${apiBiPath}/contact/getContactEntity`,params)
export const getContactTags=params=>get(`${apiBiPath}/contact/getContactTags`,params)
//ca
export const getHopper=params=>get(`${apiBiPath}/log/getHopper`,params)
export const getDataPages=params=>get(`${apiBiPath}/log/getDataPages`,params)
export const getPageEvents=params=>get(`${apiBiPath}/log/getPageEvents`,params)
export const getVisiteLogProp=params=>get(`${apiBiPath}/log/getVisiteLogProp`,params)
export const getVisiteLogPropValue=params=>get(`${apiBiPath}/log/getVisiteLogPropValue`,params)
export const saveHopper=params=>get(`${apiBiPath}/log/saveHopper`,params)
export const getHopperBySaved=params=>get(`${apiBiPath}/log/getHopperBySaved`,params)
export const getHopperPageList=params=>get(`${apiBiPath}/log/getHopperPageList`,params)
export const deleteHopper=params=>get(`${apiBiPath}/log/deleteHopper`,params)
export const getDataPagesAndEvents=params=>get(`${apiBiPath}/log/getDataPagesAndEvents`,params)

export const getActiveItemList=params=>get(`${apiPath}/activeManage/getActiveItemList`,params)
export const getActiveCutRuleList=params=>get(`${apiPath}/cutRule/getList`,params)
export const deleteCutRule=params=>get(`${apiPath}/cutRule/delete`,params)
export const saveCutRule=params=>get(`${apiPath}/cutRule/save`,params)
export const deleteActiveItem=params=>get(`${apiPath}/activeManage/deleteActiveItem`,params)
export const saveActiveItem=params=>get(`${apiPath}/activeManage/saveActiveItem`,params)
export const saveItemSalePriceList=params=>get(`${apiPath}/activeManage/saveItemSalePriceList`,params)
export const setActiveItemStatus=params=>get(`${apiPath}/activeManage/setActiveItemStatus`,params)

export const getWordsPageList=params=>get(`${apiPath}/distribution/getWordsList`,params)
export const saveWords=params=>get(`${apiPath}/distribution/saveWords`,params)
export const getWordsEntity=params=>get(`${apiPath}/distribution/getWordsEntity`,params)
export const delWordsEntity=params=>get(`${apiPath}/distribution/deleteWords`,params)

export const getCardFreeList=params=>get(`${apiPath}/prepay/getCardFreeList`,params)
export const saveCardFree=params=>get(`${apiPath}/prepay/saveCardFree`,params)
export const deletePrepayCardFree=params=>get(`${apiPath}/prepay/deletePrepayCardFree`,params)
export const getSinglePrepayCardFree=params=>get(`${apiPath}/prepay/getSinglePrepayCardFree`,params)
export const getCardBatchOptionList=params=>get(`${apiPath}/prepay/getCardBatchOptionList`,params)
export const getOptionFreeList=params=>get(`${apiPath}/free/getOptionFreeList`,params)
export const copyCardItem=params=>get(`${apiPath}/prepay/copyCardItem`,params)
export const saveFullProductSort=params=>get(`${apiPath}/fullcut/saveFullProductSort`,params)

//获取绑定码列表
export const getBindCodeList=params=>get(`${apiPath}/mediaManage/getActiveListByActiveType`,params)

//礼品卡
export const findBalanceCardBatches=params=>get(`${apiBalancePath}/giftCard/getOutboundList`,params)
export const getBalanceCardOutData=params=>get(`${apiBalancePath}/giftCard/getOutboundRecordList`,params)
export const getBalanceCardDetail=params=>get(`${apiBalancePath}/giftCard/getGiftCard`,params)
export const getUserListForDropbox=params=>get(`${apiBaseservicePath}/user/getUserListForDorpbox`,params)
export const balanceCardModuleDownload=`${baseUrl}/${apiBalancePath}/giftCard/download`
export const balanceCardModuleUpload=params=>postEspec(`${apiBalancePath}/giftCard/processInbound`,params)
export const balanceCardInventoryUpload=params=>postEspec(`${apiBalancePath}/giftCard/processActive`,params)
export const balanceCardOut=params=>post(`${apiBalancePath}/giftCard/processOutbound`,params)
export const balanceInventoryRecords=params=>get(`${apiBalancePath}/giftCard/getCardStockList`,params)

//外呼
export const getCallCondition=params=>get(`${apiPath}/aiCall/getCallCondition`,params)
export const getMaterialClass=params=>get(`${apiPath}/aiCall/getMaterialClass`,params)
export const saveMatClass=params=>post(`${apiPath}/aiCall/saveMaterialClass`,params)



// WEBPACK FOOTER //
// ./src/api/api.js